import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const SpaceContext = createContext(null);

export function SpaceProvider({ children }) {
  const [spaces, setSpaces] = useState([]);
  const [activeSpace, setActiveSpace] = useState(null);
  const [loading, setLoading] = useState(false);

  const upsertSpace = useCallback((space) => {
    if (!space?._id) return;

    setSpaces((prev) => {
      const existingIndex = prev.findIndex((entry) => entry._id === space._id);
      if (existingIndex === -1) {
        return [space, ...prev];
      }

      const next = [...prev];
      next[existingIndex] = { ...next[existingIndex], ...space };
      return next;
    });

    setActiveSpace((prev) => (prev?._id === space._id ? { ...(prev || {}), ...space } : prev));
  }, []);

  const fetchSpaces = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/spaces');
      setSpaces(res.data.spaces || []);
    } catch (err) {
      console.error('Failed to fetch spaces:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSpaces();
  }, [fetchSpaces]);

  const createSpace = async (data) => {
    const res = await api.post('/spaces', data);
    upsertSpace(res.data.space);
    return res.data.space;
  };

  const selectSpace = async (spaceId) => {
    const found = spaces.find((s) => s._id === spaceId);
    if (found) {
      setActiveSpace(found);
      return found;
    }
    const res = await api.get(`/spaces/${spaceId}`);
    upsertSpace(res.data.space);
    return res.data.space;
  };

  return (
    <SpaceContext.Provider value={{ spaces, activeSpace, loading, fetchSpaces, createSpace, selectSpace, upsertSpace }}>
      {children}
    </SpaceContext.Provider>
  );
}

export const useSpaces = () => useContext(SpaceContext);
